import styled, { css } from 'styled-components'
import colors from '../../../../configuration/colors'
import Select from 'react-select'
import TextareaAutosize from 'react-autosize-textarea'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import reactSelectBaseStyles from '../../../../configuration/ReactSelect'
import editIconSvg from '../../../../static/images/icons/icon_edit.svg'
import trashIconSvg from '../../../../static/images/icons/icon_trash_red_outline.svg'

export const ModalWrapper = styled.div`
  width: 660px;
`

export const DeleteModalWrapper = styled.div`
  width: 519px;
  margin: 20px 0 24px 0;
  text-align: center;
`

export const ModalSubheaderWrapper = styled(FlexAlignCenter)`
  padding: 10px 28px;
  border-bottom: 1px solid ${props => props.theme.rockLine};
`

export const FormInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

const inputTypography = css`
  color: ${colors.black};
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 400;
`

export const InputTypography = styled.div`
  ${inputTypography}
  ${props => props.capitalize && 'text-transform: capitalize;'}
  margin-bottom: 15px;
`

const textInput = css`
  ${inputTypography}
  border-radius: 5px;
  border: 0.5px solid ${colors.silver};
  width: 100%;
  padding: 12px;

  &::placeholder {
    color: ${colors.aluminum};
    font-weight: 300;
  }
`

export const TextInput = styled.input.attrs({
  type: 'text'
})`
  ${textInput}
  height: 42px;
  margin-bottom: ${props => props.invalid ? '0' : '15px'};
`

export const RadioInput = styled.input.attrs({
  type: 'radio'
})`
  height: auto;
  margin-bottom: 0;
`

export const FileInput = styled.input.attrs({
  type: 'file',
  name: 'file'
})`
  height: auto;
  width: 100%;
  padding: 0;
  margin-bottom: 6px;
  background: transparent;
  color: ${colors.charcoal4};
`

export const TextareaAutosizeStyled = styled(TextareaAutosize).attrs( props => ({
  rows: 2,
  maxLength: props.isJourney ? 80 : null
}))`
  ${textInput}
  resize: none;
  max-height: 124px;
`

const ButtonMinimal = styled.button`
  background: transparent;
  font-size: 16px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
`

const Button = styled(ButtonMinimal)`
  min-width: 100px;
  height: 40px;
  padding: 0 25px;
  margin-left: 15px;
  border-radius: 20px;
  color: ${colors.charcoal4};
`

export const CancelButton = styled(Button)`
  border: 1px solid ${colors.aluminum};
`

export const SaveButton = styled(Button)`
  background: ${colors.oeYellow};
  border: none;

  &:disabled {
    background: ${colors.ash};
    color: ${colors.white};
  }
`

export const DeleteButton = styled(ButtonMinimal)`
  color: ${colors.black};
  border: 1px solid #D23A3D;
  margin-left: 22px;
  width: 129px;
  height: 45px;
  border-radius: 25px;
`

export const DeleteCancelButton = styled(ButtonMinimal)`
  border: none;
  color: #333;
  height: 45px;
`

export const H3Delete = styled.h3`
  color: ${colors.black};
  font-family: 'Lato', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  margin: 13px 0 10px 0;
`

export const DeleteDivider = styled.div`
  width: 100%;
  border: 1px solid #EEE;
  margin-top: 34px;
  margin-bottom: 20px;
`

export const InputLabel = styled.label`
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: ${colors.dove};

  ${props => props.required && css`
    ::after {
      content: " *";
      color: ${colors.crimson};
      font-size: 14px;
    }
  `}
`

export const InvalidUrlWarning = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.crimson};
  margin-top: 1px;
  margin-bottom: 13px;
`
export const MaxCharactersWrapper = styled.div`
  width: 100%;
  text-align: left;
`
export const MaxCharacters = styled.div`
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: #BBB;
  margin-top: 1px;
  margin-bottom: 13px;
`

export const RadioLabel = styled.label`
  color: ${colors.charcoal4};
  font-family: Lato, sans-serif;
  font-size: 13px;
  line-height: 22px;
  width: 48px;
  margin: 0 8px;
  text-align: left;
`

export const RadioContainer = styled(FlexAlignCenter)`
  margin: 10px 0 18px 0;
`

export const FileUploaderWrapper = styled.div`
  margin-top: 6px;
  margin-bottom: 15px;
  width: 100%;
  text-align: left;
`

export const UploadedFilename = styled.div`
  ${inputTypography}
`

export const CancelFileUploadButton = styled.div.attrs({
  className: 'caption4'
})`
  cursor: pointer;
  font-weight: bold;
  color: ${colors.cobalt};
`

export const FileSizeLimit = styled.div.attrs({
  className: 'caption1'
})`
  ${props => props.emphasize && css`
    color: ${colors.crimson};
  `}
`

export const AllSectionsLabel = styled.div`
  font-weight: bold;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
`

export const EditIcon = styled.img.attrs({
  src: editIconSvg
})`
  margin-right: 11px;
`

export const TrashIcon = styled.img.attrs({
  src: trashIconSvg
})``

export const MutateMenuWrapper = styled.div`
  position: absolute;
  top: 11px;
  right: 8px;
`

export const AvatarWrapper = styled.div`
  position: absolute;
  bottom: 6px;
  right: 6px;
`

export const selectStyles = Object.assign({}, reactSelectBaseStyles)

selectStyles.container = provided => ({
  ...provided,
  width: '100%',
  height: '42px',
  marginBottom: '20px'
})

selectStyles.control = provided => {
  return {
    ...provided,
    width: '100%',
    height: '42px',
    cursor: 'pointer',
    boxShadow: 'none',
    border: `1px solid ${colors.silver} !important`,
    background: colors.white
  }
}

selectStyles.singleValue = provided => {
  return {
    ...provided,
    color: colors.black,
    fontFamily: "'Lato', san-serif",
    fontSize: '16px',
    fontWeight: '400'
  }
}

selectStyles.placeholder = provided => ({
  ...provided,
  color: colors.aluminum,
  fontFamily: 'Lato',
  fontSize: '16px',
  lineHeight: '19px',
  fontWeight: '300',
})

selectStyles.option = (provided, state) => {
  return {
    ...provided,
    background: `${state.isFocused ? colors.selectOptionFocusBackground : colors.white} !important`,
    color: colors.charcoal4,
    textAlign: 'left',
    fontSize: '16px',
    fontWeight: '300',
    cursor: 'pointer',
    paddingLeft: '22px'
  }
}
